/**
 * @fuegokit/tokens 0.10.7
 * Do not edit directly
 * Generated on Wed, 20 Sep 2023 00:32:17 GMT
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
  scale: {
    gray: {
      "100": "#C7CED6",
      "200": "#B5BEC9",
      "300": "#A3AEBD",
      "400": "#929FB0",
      "500": "#6B778C",
      "600": "#505F79",
      "700": "#344563",
      "800": "#172B4D",
      "900": "#091E42",
      "000": "#FAFBFC",
    },
    neutral: {
      "100": "#1D2125",
      "200": "#22272B",
      "300": "#2C333A",
      "400": "#454F59",
      "500": "#596773",
      "600": "#738496",
      "700": "#8696A7",
      "800": "#9FADBC",
      "900": "#B6C2CF",
      "1000": "#C7D1DB",
      "1100": "#DEE4EA",
      "000": "#161A1D",
    },
    neutralAlpha: {
      "100": "#bcd6f00a",
      "200": "#a1bdd914",
      "300": "#a6c5e229",
      "400": "#bfdbf847",
      "500": "#9bb4ca80",
      "000": "#00000000",
    },
    blue: {
      "100": "#CCE0FF",
      "200": "#85B8FF",
      "300": "#579DFF",
      "400": "#388BFF",
      "500": "#1D7AFC",
      "600": "#0C66E4",
      "700": "#0055CC",
      "800": "#09326C",
      "900": "#082145",
      "000": "#E9F2FF",
    },
    teal: {
      "100": "#C1F0F5",
      "200": "#8BDBE5",
      "300": "#60C6D2",
      "400": "#37B4C3",
      "500": "#1D9AAA",
      "600": "#1D7F8C",
      "700": "#206B74",
      "800": "#1D474C",
      "900": "#153337",
      "000": "#E3FAFC",
    },
    purple: {
      "100": "#DFD8FD",
      "200": "#B8ACF6",
      "300": "#9F8FEF",
      "400": "#8F7EE7",
      "500": "#8270DB",
      "600": "#6E5DC6",
      "700": "#5E4DB2",
      "800": "#352C63",
      "900": "#231C3F",
      "000": "#F3F0FF",
    },
    green: {
      "100": "#BAF3DB",
      "200": "#7EE2B8",
      "300": "#4BCE97",
      "400": "#2ABB7F",
      "500": "#22A06B",
      "600": "#1F845A",
      "700": "#216E4E",
      "800": "#164B35",
      "900": "#133527",
      "000": "#DFFCF0",
    },
    yellow: {
      "100": "#F8E6A0",
      "200": "#F5CD47",
      "300": "#E2B203",
      "400": "#CF9F02",
      "500": "#B38600",
      "600": "#946F00",
      "700": "#7F5F01",
      "800": "#533F04",
      "900": "#3D2E00",
      "000": "#FFF7D6",
    },
    red: {
      "100": "#FFD2CC",
      "200": "#FF9C8F",
      "300": "#F87462",
      "400": "#EF5C48",
      "500": "#E34935",
      "600": "#CA3521",
      "700": "#AE2A19",
      "800": "#601E16",
      "900": "#391813",
      "000": "#FFEDEB",
    },
    orange: {
      "100": "#FFE2BD",
      "200": "#FEC57B",
      "300": "#FAA53D",
      "400": "#F18D13",
      "500": "#D97008",
      "600": "#B65C02",
      "700": "#974F0C",
      "800": "#5F3811",
      "900": "#43290F",
      "000": "#FFF4E5",
    },
    magenta: {
      "100": "#FDD0EC",
      "200": "#F797D2",
      "300": "#E774BB",
      "400": "#DA62AC",
      "500": "#CD519D",
      "600": "#AE4787",
      "700": "#943D73",
      "800": "#50253F",
      "900": "#341829",
      "000": "#FFECF8",
    },
    transparentAlpha: {
      "100": "#ffffff14",
      "200": "#ffffff29",
      "300": "#ffffff3d",
      "400": "#ffffff52",
      "500": "#ffffff7a",
      "000": "#ffffff00",
    },
  },
  text: {
    default: "#C7D1DB",
    subtle: "#9FADBC",
    subtlest: "#8696A7",
    disabled: "#596773",
    inverse: "#161A1D",
    brand: "#579DFF",
    selected: "#579DFF",
    danger: "#FF9C8F",
    success: "#7EE2B8",
    discovery: "#B8ACF6",
    information: "#85B8FF",
    accent: {
      blue: {
        default: "#85B8FF",
        bolder: "#CCE0FF",
      },
      red: {
        default: "#FF9C8F",
        bolder: "#FFD2CC",
      },
      orange: {
        default: "#FEC57B",
        bolder: "#FFE2BD",
      },
      yellow: {
        default: "#F5CD47",
        bolder: "#F8E6A0",
      },
      green: {
        default: "#7EE2B8",
        bolder: "#BAF3DB",
      },
      purple: {
        default: "#B8ACF6",
        bolder: "#DFD8FD",
      },
      teal: {
        default: "#8BDBE5",
        bolder: "#C1F0F5",
      },
      magenta: {
        default: "#F797D2",
        bolder: "#FDD0EC",
      },
      gray: {
        default: "#9FADBC",
        bolder: "#C7D1DB",
      },
    },
    warning: {
      default: "#F5CD47",
      inverse: "#161A1D",
    },
  },
  icon: {
    default: "#9FADBC",
    subtle: "#8696A7",
    inverse: "#161A1D",
    disabled: "#596773",
    brand: "#579DFF",
    selected: "#579DFF",
    danger: "#EF5C48",
    success: "#2ABB7F",
    discovery: "#8F7EE7",
    information: "#388BFF",
    accent: {
      blue: "#388BFF",
      red: "#EF5C48",
      orange: "#F18D13",
      yellow: "#CF9F02",
      green: "#2ABB7F",
      purple: "#8F7EE7",
      teal: "#37B4C3",
      magenta: "#DA62AC",
      gray: "#738496",
    },
    warning: {
      default: "#CF9F02",
      inverse: "#161A1D",
    },
  },
  border: {
    default: "#a6c5e229",
    inverse: "#161A1D",
    focused: "#CCE0FF",
    input: "#a6c5e229",
    disabled: "#a1bdd914",
    brand: "#579DFF",
    selected: "#579DFF",
    danger: "#EF5C48",
    warning: "#F18D13",
    success: "#2ABB7F",
    discovery: "#8F7EE7",
    information: "#388BFF",
    subtle: "#a1bdd914",
    accent: {
      blue: "#388BFF",
      red: "#EF5C48",
      orange: "#FAA53D",
      yellow: "#CF9F02",
      green: "#2ABB7F",
      purple: "#8F7EE7",
      teal: "#37B4C3",
      magenta: "#DA62AC",
      table: {
        default: "#a6c5e229",
      },
      gray: "#738496",
    },
  },
  background: {
    disabled: "#a1bdd914",
    accent: {
      blue: {
        subtlest: "#082145",
        subtler: "#09326C",
        subtle: "#0055CC",
        bolder: "#579DFF",
      },
      red: {
        subtlest: "#391813",
        subtler: "#601E16",
        subtle: "#AE2A19",
        bolder: "#F87462",
      },
      orange: {
        subtlest: "#43290F",
        subtler: "#5F3811",
        subtle: "#974F0C",
        bolder: "#FAA53D",
      },
      yellow: {
        subtlest: "#3D2E00",
        subtler: "#533F04",
        subtle: "#7F5F01",
        bolder: "#E2B203",
      },
      green: {
        subtlest: "#133527",
        subtler: "#164B35",
        subtle: "#216E4E",
        bolder: "#4BCE97",
      },
      teal: {
        subtlest: "#153337",
        subtler: "#1D474C",
        subtle: "#206B74",
        bolder: "#60C6D2",
      },
      purple: {
        subtlest: "#231C3F",
        subtler: "#352C63",
        subtle: "#5E4DB2",
        bolder: "#9F8FEF",
      },
      magenta: {
        subtlest: "#341829",
        subtler: "#50253F",
        subtle: "#943D73",
        bolder: "#E774BB",
      },
      gray: {
        subtlest: "#2C333A",
        subtler: "#2C333A",
        subtle: "#596773",
        bolder: "#8696A7",
      },
    },
    inverse: {
      subtle: {
        default: "#ffffff29",
        hovered: "#ffffff3d",
        pressed: "#ffffff52",
      },
    },
    input: {
      default: "#1D2125",
      hovered: "#22272B",
      pressed: "#1D2125",
    },
    neutral: {
      default: {
        "[default]": "#a1bdd914",
        hovered: "#a6c5e229",
        pressed: "#bfdbf847",
      },
      subtle: {
        default: "#00000000",
        hovered: "#a1bdd914",
        pressed: "#a6c5e229",
      },
      bold: {
        default: "#9FADBC",
        hovered: "#B6C2CF",
        pressed: "#C7D1DB",
      },
    },
    brand: {
      bold: {
        default: "#579DFF",
        hovered: "#85B8FF",
        pressed: "#CCE0FF",
      },
    },
    selected: {
      default: {
        "[default]": "#082145",
        hovered: "#09326C",
        pressed: "#0055CC",
      },
      bold: {
        default: "#579DFF",
        hovered: "#85B8FF",
        pressed: "#CCE0FF",
      },
    },
    danger: {
      default: {
        "[default]": "#391813",
        hovered: "#601E16",
        pressed: "#AE2A19",
      },
      bold: {
        default: "#F87462",
        hovered: "#FF9C8F",
        pressed: "#FFD2CC",
      },
    },
    warning: {
      default: {
        "[default]": "#3D2E00",
        hovered: "#533F04",
        pressed: "#7F5F01",
      },
      bold: {
        default: "#E2B203",
        hovered: "#F5CD47",
        pressed: "#F8E6A0",
      },
    },
    success: {
      default: {
        "[default]": "#133527",
        hovered: "#164B35",
        pressed: "#216E4E",
      },
      bold: {
        default: "#4BCE97",
        hovered: "#7EE2B8",
        pressed: "#BAF3DB",
      },
    },
    discovery: {
      default: {
        "[default]": "#231C3F",
        hovered: "#352C63",
        pressed: "#5E4DB2",
      },
      bold: {
        default: "#9F8FEF",
        hovered: "#B8ACF6",
        pressed: "#DFD8FD",
      },
    },
    information: {
      default: {
        "[default]": "#082145",
        hovered: "#09326C",
        pressed: "#0055CC",
      },
      bold: {
        default: "#579DFF",
        hovered: "#85B8FF",
        pressed: "#CCE0FF",
      },
    },
  },
  blanket: {
    default: "#03040442",
    selected: "#1d7afc14",
    danger: "#e3493514",
  },
  interaction: {
    hovered: "#00000029",
    pressed: "#00000052",
    inverse: {
      hovered: "#ffffff33",
      pressed: "#ffffff5c",
    },
  },
  skeleton: {
    default: "#a1bdd914",
    subtle: "#bcd6f00a",
  },
  link: {
    default: "#579DFF",
    pressed: "#85B8FF",
  },
  palette: {
    Blue100: "#E9F2FF",
    Blue200: "#CCE0FF",
    Blue300: "#85B8FF",
    Blue400: "#579DFF",
    Blue500: "#388BFF",
    Blue600: "#1D7AFC",
    Blue700: "#0C66E4",
    Blue800: "#0055CC",
    Blue900: "#09326C",
    Blue1000: "#082145",
    Red100: "#FFEDEB",
    Red200: "#FFD2CC",
    Red300: "#FF9C8F",
    Red400: "#F87462",
    Red500: "#EF5C48",
    Red600: "#E34935",
    Red700: "#CA3521",
    Red800: "#AE2A19",
    Red900: "#601E16",
    Red1000: "#391813",
    Yellow100: "#FFF7D6",
    Yellow200: "#F8E6A0",
    Yellow300: "#F5CD47",
    Yellow400: "#E2B203",
    Yellow500: "#CF9F02",
    Yellow600: "#B38600",
    Yellow700: "#946F00",
    Yellow800: "#7F5F01",
    Yellow900: "#533F04",
    Yellow1000: "#3D2E00",
    Green100: "#DFFCF0",
    Green200: "#BAF3DB",
    Green300: "#7EE2B8",
    Green400: "#4BCE97",
    Green500: "#2ABB7F",
    Green600: "#22A06B",
    Green700: "#1F845A",
    Green800: "#216E4E",
    Green900: "#164B35",
    Green1000: "#133527",
    Purple100: "#F3F0FF",
    Purple200: "#DFD8FD",
    Purple300: "#B8ACF6",
    Purple400: "#9F8FEF",
    Purple500: "#8F7EE7",
    Purple600: "#8270DB",
    Purple700: "#6E5DC6",
    Purple800: "#5E4DB2",
    Purple900: "#352C63",
    Purple1000: "#231C3F",
    Teal100: "#E3FAFC",
    Teal200: "#C1F0F5",
    Teal300: "#8BDBE5",
    Teal400: "#60C6D2",
    Teal500: "#37B4C3",
    Teal600: "#1D9AAA",
    Teal700: "#1D7F8C",
    Teal800: "#206B74",
    Teal900: "#1D474C",
    Teal1000: "#153337",
    Orange100: "#FFF4E5",
    Orange200: "#FFE2BD",
    Orange300: "#FEC57B",
    Orange400: "#FAA53D",
    Orange500: "#F18D13",
    Orange600: "#D97008",
    Orange700: "#B65C02",
    Orange800: "#974F0C",
    Orange900: "#5F3811",
    Orange1000: "#43290F",
    Magenta100: "#FFECF8",
    Magenta200: "#FDD0EC",
    Magenta300: "#F797D2",
    Magenta400: "#E774BB",
    Magenta500: "#DA62AC",
    Magenta600: "#CD519D",
    Magenta700: "#AE4787",
    Magenta800: "#943D73",
    Magenta900: "#50253F",
    Magenta1000: "#341829",
    "DarkNeutral-100": "#101214",
    "DarkNeutral-100A": "#03040442",
    DarkNeutral0: "#161A1D",
    DarkNeutral100: "#1D2125",
    DarkNeutral100A: "#bcd6f00a",
    DarkNeutral200: "#22272B",
    DarkNeutral200A: "#a1bdd914",
    DarkNeutral300: "#2C333A",
    DarkNeutral300A: "#a6c5e229",
    DarkNeutral400: "#454F59",
    DarkNeutral400A: "#bfdbf847",
    DarkNeutral500: "#596773",
    DarkNeutral500A: "#9bb4ca80",
    DarkNeutral600: "#738496",
    DarkNeutral700: "#8696A7",
    DarkNeutral800: "#9FADBC",
    DarkNeutral900: "#B6C2CF",
    DarkNeutral1000: "#C7D1DB",
    DarkNeutral1100: "#DEE4EA",
  },
  chart: {
    brand: {
      default: "#388BFF",
      hovered: "#579DFF",
    },
    neutral: {
      default: "#738496",
      hovered: "#8696A7",
    },
    success: {
      default: {
        "[default]": "#2ABB7F",
        hovered: "#4BCE97",
      },
      bold: {
        default: "#7EE2B8",
        hovered: "#BAF3DB",
      },
    },
    danger: {
      default: {
        "[default]": "#E34935",
        hovered: "#EF5C48",
        pressed: "#AE2A19",
      },
      bold: {
        default: "#FF9C8F",
        hovered: "#FFD2CC",
        pressed: "#FFEDEB",
      },
    },
    warning: {
      default: {
        "[default]": "#CF9F02",
        hovered: "#E2B203",
      },
      bold: {
        default: "#F5CD47",
        hovered: "#F8E6A0",
      },
    },
    information: {
      default: {
        "[default]": "#1D7AFC",
        hovered: "#388BFF",
      },
      bold: {
        default: "#85B8FF",
        hovered: "#CCE0FF",
      },
    },
    discovery: {
      default: {
        "[default]": "#8270DB",
        hovered: "#8F7EE7",
      },
      bold: {
        default: "#B8ACF6",
        hovered: "#DFD8FD",
      },
    },
    categorical: {
      "1": {
        default: "#1D9AAA",
        hovered: "#37B4C3",
      },
      "2": {
        default: "#B8ACF6",
        hovered: "#DFD8FD",
      },
      "3": {
        default: "#D97008",
        hovered: "#F18D13",
      },
      "4": {
        default: "#F797D2",
        hovered: "#FDD0EC",
      },
      "5": {
        default: "#CCE0FF",
        hovered: "#E9F2FF",
      },
      "6": {
        default: "#8270DB",
        hovered: "#8F7EE7",
      },
      "7": {
        default: "#FDD0EC",
        hovered: "#FFECF8",
      },
      "8": {
        default: "#FEC57B",
        hovered: "#FFE2BD",
      },
    },
    blue: {
      bold: {
        default: "#1D7AFC",
        hovered: "#388BFF",
      },
      bolder: {
        default: "#388BFF",
        hovered: "#579DFF",
      },
      boldest: {
        default: "#85B8FF",
        hovered: "#CCE0FF",
      },
    },
    red: {
      bold: {
        default: "#E34935",
        hovered: "#EF5C48",
      },
      bolder: {
        default: "#EF5C48",
        hovered: "#F87462",
      },
      boldest: {
        default: "#FF9C8F",
        hovered: "#FFD2CC",
      },
    },
    orange: {
      bold: {
        default: "#F18D13",
        hovered: "#FAA53D",
      },
      bolder: {
        default: "#FAA53D",
        hovered: "#FEC57B",
      },
      boldest: {
        default: "#FEC57B",
        hovered: "#FFE2BD",
      },
    },
    yellow: {
      bold: {
        default: "#CF9F02",
        hovered: "#E2B203",
      },
      bolder: {
        default: "#E2B203",
        hovered: "#F5CD47",
      },
      boldest: {
        default: "#F5CD47",
        hovered: "#F8E6A0",
      },
    },
    green: {
      bold: {
        default: "#2ABB7F",
        hovered: "#4BCE97",
      },
      bolder: {
        default: "#4BCE97",
        hovered: "#7EE2B8",
      },
      boldest: {
        default: "#7EE2B8",
        hovered: "#BAF3DB",
      },
    },
    teal: {
      bold: {
        default: "#37B4C3",
        hovered: "#60C6D2",
      },
      bolder: {
        default: "#60C6D2",
        hovered: "#8BDBE5",
      },
      boldest: {
        default: "#8BDBE5",
        hovered: "#C1F0F5",
      },
    },
    purple: {
      bold: {
        default: "#8270DB",
        hovered: "#8F7EE7",
      },
      bolder: {
        default: "#8F7EE7",
        hovered: "#9F8FEF",
      },
      boldest: {
        default: "#B8ACF6",
        hovered: "#DFD8FD",
      },
    },
    magenta: {
      bold: {
        default: "#CD519D",
        hovered: "#DA62AC",
      },
      bolder: {
        default: "#DA62AC",
        hovered: "#E774BB",
      },
      boldest: {
        default: "#F797D2",
        hovered: "#FDD0EC",
      },
    },
    gray: {
      bold: {
        default: "#738496",
        hovered: "#8696A7",
      },
      bolder: {
        default: "#8696A7",
        hovered: "#9FADBC",
      },
      boldest: {
        default: "#9FADBC",
        hovered: "#B6C2CF",
      },
    },
  },
  elevation: {
    surface: {
      default: {
        "[default]": "#1D2125",
        hovered: "#1D2125",
        pressed: "#22272B",
      },
      sunken: "#161A1D",
      raised: {
        default: "#1D2125",
        hovered: "#22272B",
        pressed: "#2C333A",
      },
      overlay: {
        default: "#22272B",
        hovered: "#2C333A",
        pressed: "#454F59",
      },
    },
    shadow: {
      raised: "0px 1px 1px 0px #03040480, 0px 0px 1px 0px #03040480",
      overflow: {
        default: "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480",
        spread: "#0304048f",
        perimeter: "#091e421f",
      },
      overlay: "0px 0px 0px 1px #bcd6f00a, 0px 8px 12px 0px #0304045c, 0px 0px 1px 0px #03040480",
    },
  },
};
